import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Home from './pages/Home';
import Login from './pages/Login';

import Settings from './pages/Menu/Settings';
import { SectionProvider } from './context/SelectedSectionContext';
import Subjective from './pages/Menu/Subjective';
import Assesment from './pages/Menu/Assesment';
import Plan from './pages/Menu/Plan';
import Masters from './pages/Menu/Masters';
import TeleconsultSummary from './pages/ConsultSummary/TeleConsultSummary';
import HealthVitals from './pages/Health/Health';
import AllergyMasters from './pages/Masters/allergy';
import AllergyReaction from './pages/Masters/allergyReaction';
import MedicationGeneric from './pages/Masters/medicationgeneric';
import MedicationBrand from './pages/Masters/medicationbrand';
import Medicationsigninfo from './pages/Masters/medicationsiginfo';
import Symptoms from './pages/Masters/synptoms';
import Condition from './pages/Masters/condition';
import Icd from './pages/Masters/icd';
import Lab from './pages/Masters/lab';
import Imaging from './pages/Masters/imaging';
import Procedure from './pages/Masters/procedure';
import Teleconsult from './pages/Menu/Teleconsult';
import Accounts from './pages/Menu/Accounts';
import Logout from './pages/Logout';


const App: React.FC = () => {
  return (
    <SectionProvider>
      <Router>       
        <Routes>
          <Route path="/" element={<Login />} />
          <Route path="logout" element={<Logout/>}/>
          <Route path="HealthVitals/:refNumber" element={<HealthVitals />} />
          <Route path="teleconsultsummary/:publishertoken" element={<TeleconsultSummary />} />
          <Route path="/home" element={<Home />}>
            <Route path="masters" element={<Masters />} />
            <Route path="masters/allergy-masters" element={<AllergyMasters />} />
            <Route path="masters/allergyreaction-masters" element={<AllergyReaction />} />
            <Route path="masters/medicationgeneric-masters" element={<MedicationGeneric />} />
            <Route path="masters/medicationbrand-masters" element={<MedicationBrand />} />
            <Route path="masters/medicationsiginfo-masters" element={<Medicationsigninfo />} />
            <Route path="masters/symptoms-masters" element={<Symptoms />} />
            <Route path="masters/condition-masters" element={<Condition />} />
            <Route path="masters/icd10-masters" element={<Icd />} />
            <Route path="masters/lab-masters" element={<Lab />} />
            <Route path="masters/imaging-masters" element={<Imaging />} />
            <Route path="masters/procedure-masters" element={<Procedure />} />
            <Route path="teleconsult" element={<Teleconsult />} />
            <Route path="subjective" element={<Subjective />} />
            <Route path="assessment" element={<Assesment />} />
            <Route path="plan" element={<Plan />} />
            <Route path="accounts" element={<Accounts />} />
            {/* <Route path="account" element={<Account />} /> */}
            <Route path="settings" element={<Settings id={''} />} />
            <Route path="logout" element={<Logout/>}/>
          </Route>
        </Routes>
      </Router>
    </SectionProvider>
  );
};

export default App;
